import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  FDAccordionGroup, FDSecondaryActionButton, FDSimpleAccordion, Table,
} from '@facet-wealth/design';
import TableBody from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableBody';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    backgroundColor: theme.palette.facet.whiteSmoke,
    borderRadius: theme.radius.md,
  },
  addButton: {
    marginBottom: theme.spacing(2),
  },
});

const AssumptionByDateSection = ({
  className,
  classes,
  assumptionResources,
}) => {
  const {
    loadModalCollectionByLink,
  } = useModalContext();

  const handleModifyAssumption = React.useCallback(
    assumptionEntry => {
      const selfLink = assumptionEntry.link('self');
      if (selfLink) {
        const assumptionEntrySelfLink = selfLink.url();
        loadModalCollectionByLink(assumptionEntrySelfLink);
      }
    },
    [assumptionResources],
  );

  const handleAddAssumptionEntry = React.useCallback(
    assumption => {
      if (assumption.relationship(fr.relationships.addAssumptionEntry.name)) {
        const addLink = assumption.relationship(fr.relationships.addAssumptionEntry.name).link('related').url();
        loadModalCollectionByLink(addLink);
      }
    },
    [assumptionResources],
  );

  return (
    <Box className={classNames(classes.root, className)}>
      <FDAccordionGroup>
        {assumptionResources.map(assumption => {
          return (
            <FDSimpleAccordion
              key={assumption.id()}
              expansionID={assumption.attr('assumptionName')}
              title={assumption.attr('assumptionName')}
            >
              <Box className={classNames(classes.addButton)}>
                <FDSecondaryActionButton
                  icon="add"
                  iconPosition="start"
                  label="Add New Entry"
                  onClick={assumption.relationship(fr.relationships.addAssumptionEntry.name) ? () => handleAddAssumptionEntry(assumption) : null}
                  size="sm"
                />
              </Box>
              <Table.Table size="lg">
                <Table.HeadColumnHeaderSet>
                  <Table.HeadColumnHeaderCell value="Start Date" />
                  <Table.HeadColumnHeaderCell value="Value" />
                  <Table.HeadColumnHeaderCell value="Last Changed By" />
                </Table.HeadColumnHeaderSet>
                <TableBody>
                  {assumption.attr('facetPlanAssumptionByDateEntries').resources().list().map(entry => {
                    return (
                      <Table.BodyRow key={entry.id()} onClick={entry.link('self') ? () => handleModifyAssumption(entry) : null}>
                        <Table.BodyCellText value={entry.attr('startDate')} />
                        <Table.BodyCellText value={entry.attr('formattedValue')} />
                        <Table.BodyCellText value={entry.attr('changedByPersonName')} />
                      </Table.BodyRow>
                    );
                  })}
                </TableBody>
              </Table.Table>
            </FDSimpleAccordion>
          );
        })}
      </FDAccordionGroup>
    </Box>
  );
};

AssumptionByDateSection.defaultProps = {
  className: '',
};

AssumptionByDateSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  assumptionResources: PropTypes.array.isRequired,
};

export default withStyles(styles)(AssumptionByDateSection);
